import navigate from "./navigate"

export default [...navigate]
